import { React } from "react";

import PageTitle from "../../Share/PageTitle";
import ReactMarkdown from "react-markdown";
import "./markdown.css";

const ConstitutionPage = () => {
  // const [constitution, setConstitution] = useState("");

  // useEffect(async () => {
  //     try {
  //         const response = await axios.get("https://rawgithubusercontent.com/ummgc-parliamentarian/test-constitution/main/constitution.MD?token=GHSAT0AAAAAAB2J2TO7QOKB5GTXKWATFC22Y2WVD2A")
  //         console.log(response)
  //         // setConstitution(response)
  //     } catch (error){
  //         console.log(error)
  //     }
  // })

  const constitution = `
# THE CONSTITUTION OF THE UNIVERSITY OF MICHIGAN MEN’S GLEE CLUB

## As Revised and Ratified on the 23rd day of October in the Year of the Common Era 2022, by the Men’s Glee Club the 163th.

## PREAMBLE

The University of Michigan Men’s Glee Club is an ensemble dedicated to musical excellence in the male chorus tradition. We are proud of our reputation and reaffirm our long-standing commitment to represent ourselves, our alumni, the University, the State, and the Nation, as well as we are able. Though our members have diverse personal backgrounds, we are united as a social institution with a communitarian spirit and a collective purpose. We strive to offer our members opportunities for the development of leadership skills and for the advancement of educational goals. We also seek to provide a supportive community founded upon the pillars of Tradition, Camaraderie, and Musical Excellence, where we can all work to improve ourselves and the organization as a whole, with the expectation that others will respect us and reciprocate our efforts.

## ARTICLE I. NAME 

### Section 1. _Name and Purpose_  

[1] The Name of this organization is The University of Michigan Men’s Glee Club, hereafter referred to as “the Glee Club.”

[2] The purpose of the Glee Club is to perpetuate the musical heritage of the University of Michigan, to promote fellowship among its members, to represent the University of Michigan through the medium of music, and to further the musical ability of its members.

[3] The UMMGC operates as both an SSO of the University and a class in the SMTD. All operations of the Club are subject to restrictions due to its status as both a class and a SSO.

[4] The Glee Club shall operate at all times in accordance with the provisions of section 501(c)(3) of the Internal Revenue Code. No part of the net earnings of the Glee Club shall inure to the benefit of, or be distributable to its members, officers, the director, or other private persons, except that the Glee Club shall be authorized and empowered to pay reasonable compensation for services rendered and to make payments and distributions in furtherance of the purposes set forth in Amendment I hereof. No substantial part of the activities of the Glee Club shall be the carrying on of propaganda, or otherwise attempting to influence legislation, and the Glee Club shall not participate in, or intervene in (including the publishing or distribution of statements) any political campaign on behalf of or in opposition to any candidate for public office. Notwithstanding any other provision of this Constitution, the Glee Club shall not, except to an insubstantial degree, engage in any activities or exercise any powers that are not in furtherance of the purposes of the Glee Club.

## ARTICLE II. MEMBERSHIP

### Section 1. _Definition of Membership_
Membership in good standing in the Glee Club shall, for the purposes of this Constitution, be defined as the right to attend and vote in business meetings, the right to run for office, and all other rights and privileges not explicitly mandated by the course syllabus.

### Section 2. _Eligibility and Auditions_

[1] Any student identifying as male or non-binary enrolled at the University of Michigan or any of its satellite campuses may audition for membership. 

[2] Auditions for membership in the Glee Club shall be held at the discretion of the Executive Committee. Reasonable public notice shall be made of the time and place of auditions.

[3] The Executive Committee and the Music Director shall, by mutual agreement, accept new members based upon the candidates’ auditions, with consideration to the specific needs of the Glee Club.

### Section 3. _Leaves of Absence and Post-Graduation Eligibility_

[1] Barring loss of good standing, membership in the Glee Club shall automatically be reserved each semester unless the member indicates to the Executive Committee his intention to leave the Glee Club, and in any event shall be revoked after a member ceases to be enrolled at the University of Michigan except for cases referring to Art. II, Sec. 3, [2] & [4].

[2] After graduation, a member may continue his membership for the following one (1) academic year (Fall term thru Winter term). A Member who graduates at the end of Fall term shall be granted the option to remain a member for the remainder of the academic year in which he graduates in addition to the following one (1) academic year.

[3] The Executive Committee shall have the authority to grant a member a leave of absence of up to one (1) year. Members may apply for a leave of absence up until the academic drop/add deadline of the School of Music, Theatre & Dance of a given term.

[4] A member may continue his membership for one (1) semester in which he is not enrolled at the University of Michigan, provided he is eligible to enroll at the University in the following semester and intends to do so. He must follow the same procedure as in Article II Sec 2 [3] (see below) and notify the executive committee of his situation or else his membership in the Glee Club will automatically be revoked.

### Section 4. _Dismissal_

[1] A Member may be dismissed from good standing in the Glee Club for:

i. Unexcused absence from a Performance;

ii. Exceeding the maximum number of unexcused absences in a term; or

iii. Commission of an indiscretion that is contrary to the principles of the Glee Club.

[2] A Member may be asked to re-audition for failing to meet the Music Director’s minimum expectations as outlined in the course syllabus.

[3] Both the Executive Board and the Music Director shall consult with one another before revoking a Member’s good standing or mandating that he re-audition.

## ARTICLE III. OPERATIONS

### Section 1. _Business Meetings_

[1] Business meetings shall be held following all regularly scheduled rehearsals, or at the discretion of the Executive Committee.

[2] A quorum for Business Meetings shall be two-thirds (2/3) of the total membership. A quorum must be established for a vote to be binding.

[3] A simple majority of the votes cast at a Business Meeting is binding. The Music Director, Assistant Music Director, Accompanist, and Advisor are non-voting members of the Glee Club.

[4] The President shall chair all discussion during business meetings, except as he relinquishes the floor to the Music Director for discussion of musical matters.

[5] Business meetings shall be governed by the Standing Rules of the Glee Club.

### Section 2. _Annual Meeting_

[1] The President, Vice-President and Parliamentarian shall be elected at the Annual Meeting of the Glee Club.

[2] The Executive Committee shall set the time and place of the Annual Meeting and provide reasonable notice of at least two (2) weeks prior to the Annual Meeting. If the Executive Committee judges that it is necessary to hold the Annual Meeting earlier than forty-five (45) days prior to the commencement of Winter Term examination period, it shall propose such a date and time at a regular Business Meeting, along with an explanation of why it believes an earlier date is necessary. The proposed date shall only be confirmed if it is approved by three-fourths (3/4) of the total voting membership in attendance at the Business Meeting. The Annual Meeting can be a regular Business Meeting.

[3] Any voting member of the Glee Club is eligible for election to any office, and may be nominated by any member not then a member of the Executive Committee.

[4] The Annual Meeting shall be conducted in accordance with the Standing Rules of the Glee Club.

### Section 3. _Tour Group_

[1] The size of the tour group and date upon which the tour group is to be selected shall be determined by the Executive Committee. Notice shall be given to the membership of the Glee Club two (2) weeks prior to tour group selection.

[2] The tour group shall be assembled in the following order of priority:

i. The top tour-eligible point-earners from each section, limited by the size of the tour group.

ii. The top tour-eligible point-earner among those who have been in the Glee Club for less than two full terms.

iii. Four members to be chosen by the Music Director, irrespective of those members’ point totals.

[3] A member must earn seniority points in both the semester preceding and the semester in which the tour list is made in order to be eligible for that tour. Ineligible members shall be added to the tour list, according to section needs, in order of points precedence only when the list of eligible members has been exhausted.

[4] Current members who either were not members or were inactive during the semester preceding the compilation of the tour list must earn seniority only for the term in which the tour list is compiled.

[5] The Music Director, Assistant Director, and the Accompanist are not bound by the point system. They may go on all tours.

[6] Prior to the selection of the tour group current members must be informed of the base cost of tour, and approximately the number of meals to be paid for out-of-pocket.

[7] In years where a tour subsidy is offered by the Glee Club, the Executive Committee shall determine the total amount of money available for subsidy and shall notify the Glee Club that subsidies are available. The award of subsidies to members shall be determined by the Music Director and the Faculty Advisor.

### Section 4. _Points_

[1] One (1) point shall be awarded for each hour of work. Points in excess of this ratio shall be given only with approval from a member of the Executive Committee. Points may be awarded in increments of one-half (1/2).

[2] Twenty-five (25) seniority points, less points lost for violations of the attendance policy and for failure to sell the required amount of tickets for Hill Auditorium Concerts, shall be given to each active member each term, provided he fulfills the following requirements each term. The deadline to meet these requirements will be voted on by the executive committee and communicated to the rest of club 2 weeks prior to its deadline, or the last day of university classes:

i. Earns a minimum of five (5) points.

ii. Attends at least 3 small group sings per semester. Under ordinary circumstances, the Small Groups Managers are considered to fulfill this requirement in the normal execution of their duties.

[3] Points shall be awarded to members of the Executive Committee each semester, contingent on their achieving seniority, as follows:

President				100

Vice-President				75 

Operations Manager			75 

Business Manager			75 

Alumni Relations Manager		75 

Publicity Manager			75 

Diversity, Equity, and Inclusion Chair     75

Parliamentarian				50 

Assistant Operations Manager		50 

Assistant Business Manager		30 

Assistant Alumni Relations Manager	30 

Assistant Publicity Manager		30 

Assistant DEI Chair                                30

Alumni Relations Manager Emeritus	30

Business Manager Emeritus		30 

Publicity Manager Emeritus		30 

DEI Chair Emeritus      			30

Operations Manager Emeritus		30

[4] The Executive Committee may delegate responsibilities to Junior Managers selected from the membership of the Glee Club. Points shall be awarded to Junior Managers each semester contingent upon their achieving seniority. A separate document shall enumerate titles, point values, and basic expectations for each position. The Executive Committee has the responsibility to finalize and publicize this document for the coming year by one (1) month before Junior Manager interviews. For exceptional cases, and according to need, the Executive Committee may add, merge, or remove positions for the coming year on the date of Junior Manager interviews after interviews have been conducted but before selections have been announced.

[5] The Executive Committee may delegate the authority to award points.

[6] Points for ticket sales shall be awarded as follows:

i. Members are required to sell fifteen (15) tickets for each Hill Auditorium Concert.

ii. If a member sells fewer than fifteen (15) tickets, a member shall lose one (1) point for each five (5) tickets, or fraction thereof, not sold.

iii. A member shall receive one half point for every ticket sold beyond the required fifteen.

iv. Points awarded for ticket sales shall not exceed the number awarded for seniority, and shall not count toward nor subtract from the number required to gain seniority.

[7] The Executive Committee may award negative points upon giving at least one (1) week’s notice to Glee Club of condition(s) under which the negative points shall be awarded. The Executive Committee itself must approve and specify the quantity of negative points which shall be awarded, and under which conditions they shall be awarded. The Executive Committee may not delegate the authority to award negative points except according to these predefined limits.

### Section 5. _Attendance and Loss of Points Resulting From Unexcused Absences_

[1] Attendance is required at all Performances, Rehearsals, Business Meetings, and the Annual Meeting.

[2] Extraordinary circumstances that merit an excused absence shall be determined by the Executive Committee, who may delegate responsibility for such determination to a specific member(s) of the Committee. An excused absence from a rehearsal shall count as an excused absence from the corresponding Business Meeting.

[3] More than five (5) unexcused absences per year or more than three (3) unexcused absences per term shall place a Member’s good standing under review.  Said Member shall have the opportunity to discuss the matter with the Executive Committee.  A final decision shall be rendered by the student members of the Executive Committee.

[4] Absence from a Business Meeting shall be deemed a lateness.

[5] Every third lateness and every lateness of greater than one-half (1/2) hour shall be termed an unexcused absence, and shall be treated in the same manner as an unexcused absence received under Article III, Section 5[6]. Latenesses shall not be considered fractions of unexcused absences.

[6] Any unexcused absence from a Performance, Rehearsal, Business Meeting or the Annual Meeting shall result in the loss of one (1) point from the twenty-five (25) seniority points that can be earned in a term.

[7] Grounds for excusal from a Rehearsal shall include, but not be limited to:

i. Death in the family

ii. Serious mental or physical illness

iii. An exam that cannot be rescheduled

iv. Observance of a religious holiday

As the professional environment becomes more competitive it is understood that “professional development” activities have become more important in order to separate oneself from the crowd. Though we still expect a substantial commitment to Glee Club, if said activities further one's studies and scholarly goals, and potential missed rehearsal dates are given with as much possible notice, the executive committee will consider making said missed rehearsals “excused” absences. These excused absences may be contingent on certain commitments of the clubber in question, such as proof of proficiency of the semester’s music for the conductor or other requirements of clubbers to achieve seniority.

As both mental and physical illnesses can manifest suddenly and confirmation of their existence by a note from a doctor, therapist, or psychologist can add an increased burden, the executive committee will assume that absences for sudden illness are requested in good faith.

### Section 6. _Member Conduct_

[1] Members of the Glee Club shall be bound by any and all policies adopted by the

Glee Club, including but not limited to the Glee Club’s Standing Rules.

[2] The Executive Committee shall have the ability to create and enforce sanctions for violations of Glee Club policies.

## ARTICLE IV. EXECUTIVE COMMITTEE

### Section 1. _Powers and Duties_

[1] The Executive Committee shall have the power and responsibility to execute and to enforce binding decisions of the Glee Club, and the power to make decisions not inconsistent with this constitution.

[2] The Music Director shall have the right to schedule four (4) concerts per term, including one (1) Hill Auditorium Concert, one (1) concert within three weeks prior to the respective Hill Auditorium Concert, and two (2) other commitments in a given term. Additional concerts may be scheduled in consultation with the executive committee. Any concert not listed on the syllabus shall be voted on by the general membership of the Glee Club.

[3] A quorum of the Executive Committee shall be six (6).

### Section 2. _Membership_

[1] The Executive Committee shall consist of the President, the Vice-President, the Operations Manager, the Business Manager, the Publicity Manager, the Alumni Relations Manager, the Music Director, the Advisor, the Parliamentarian, and the Diversity, Equity, and Inclusion (DEI) Chair.

[2] No member may hold more than one position on the Executive Committee at any time.

[3] Interviews for Assistant Executive Managers shall be held within forty-five (45) days of the beginning of Winter Term Classes. Any member may interview for any position for which they are eligible. The current Executive Committee shall appoint one (1) individual for each of the five (5) Assistant Executive Manager positions.

[4] A term of office for any student position on the Executive Committee shall be one year.

[5] There shall be two weeks notice given during regular business meetings before the appointment of a member to any office named in this Article.

### Section 3. _President_

[1] The President shall be elected at the Annual Meeting. He shall assume his duties following Spring Tour.

[2] The President shall:

i. Serve as the official representative of the Glee Club on those occasions when a sole representative is required;

ii. Preside over all Business Meetings of the Glee Club and all meetings of the Executive Committee, and shall be responsible for setting and following agendas for these meetings; and,

iii. Be empowered to resolve disputes regarding executive roles, subject to Judiciary Board review under Article III.

iv. Oversee activities including community service, community engagement, and diversity, equity, and inclusion within the Glee Club.

[3] The President shall have ex officio membership on all committees except where the Constitution provides otherwise.

[4] The president may delegate duties to the Vice-President or other individuals when appropriate.

[5] In the event of resignation or removal of the Vice-President, the President shall assume the Vice-President’s duties in addition to his own until the membership can elect a replacement.

## Section 4. _Vice-President_

[1] The Vice-President shall be elected at the Annual Meeting. He shall assume his

duties following Spring Tour.

[2] The Vice-President shall:

i. Serve as recording secretary for all Business and Executive Committee Meetings;

ii. Maintain the Club’s attendance, and point records; and,

iii. Oversee all aspects of Performances, including concert dress, walk-on, and walk-off

[3] The Vice-President shall oversee the Social Team, which shall manage activities including social events, the Glee Club’s relationship with the Women’s Glee Club, intramural sports, and New Guy support and inclusion.

[4] In the event of the resignation or removal of the President, the Vice-President shall assume the role of acting President until the Glee Club can elect a replacement.

### Section 5. _Operations Manager, and Assistant Operations manager And Operations Manager Emeritus._

[1] The Assistant Operations Manager shall assume his duties immediately after selection by the Executive Committee. Following a year of service, after interviews for Assistant Executive Managers, the previous Assistant Operations Manager shall assume the role of Operations Manager. At that time, the individual who served as Operations Manager shall become Operations Manager Emeritus. The Operations Manager Emeritus may serve for up to a half of a year.

[2] The Operations Manager shall be responsible for organizing and overseeing all aspects of the Glee Club’s operations. He shall:

i. Organize all operational aspects of Performances; and

ii. Organize all tours in consultation with the Executive Committee.

[3] The Operations Manager shall oversee the Operations Staff, which shall manage activities including the annual MVAD concert, small groups performances, tour coordination, and stage management.

[4] The Assistant Operations manager shall serve under the Operations Manager. He shall not have a vote on the Executive Committee. He shall be responsible for learning to manage and plan all Glee Club operations and assist the Operations Manager in the planning of Spring Tour.

[5] The Operations Manager Emeritus shall advise the Operations Manager and Assistant Operations Manager and shall aid in the conception and execution of Spring Tour and other operations ventures on behalf of the Glee Club. The Operations Manager Emeritus shall not have a vote on the Executive Committee.

### Section 6. _Business Manager, Assistant Business Manager, and Business Manager Emeritus_

1] The Assistant Business Manager shall assume his duties immediately after selection by the Executive Committee. Following a half year of service at the end of Spring Tour, the Assistant Business Manager shall assume the role of Business Manager. At that time, the individual who served as Business Manager shall become the Business Manager Emeritus. The Business Manager Emeritus may serve for up to one year

[2] The Business Manager shall be responsible for all Glee Club revenues, expenditures, and for maintaining accurate financial records. He shall:

i. Prepare annual financial statements for the preceding year;

ii. Prepare an annual financial report no later than four months after the end of the preceding fiscal year. He shall present the report to the Executive Committee and make copies available for the membership of the Glee Club;

iii. Prepare a budget at the beginning of each term for the following two terms. He shall present this budget to the Executive Committee for discussion, revision and adoption; and

iv. In conjunction with the advisor, reconcile the books with the University's monthly statements and present reconciliations to the Executive Committee on a regular basis.

[3] The Business Manager shall oversee the Business Committee, which shall manage activities including merchandise, tickets, sheet music purchases and distribution, and legal rights.

[4] The Assistant Business Manager shall serve under the Business Manager. He shall not have a vote on the Executive Committee. He shall be responsible for learning to manage all Glee Club accounts and assist the Business Manager with financial decisions. He shall have the power to spend with the approval of and under the supervision of the Advisor and the Business Manager and shall have all other access to Glee Club financial accounts.

[5] The Business Manager Emeritus shall advise the Business Manager and Assistant Business Manager and shall aid in the conception and execution of new financial ventures on behalf of the Glee Club. The Business Manager Emeritus shall not have a vote on the Executive Committee.

### Section 7. _Publicity Manager, Assistant Publicity Manager, and Publicity Manager Emeritus_

[1] The Assistant Publicity Manager shall assume his duties immediately after selection by the Executive Committee. Following a half year of service at the end of Spring Tour, the Assistant Publicity Manager shall assume the role of Publicity Manager. At that time, the individual who served as Publicity Manager shall become the Publicity Manager Emeritus. The Publicity Manager Emeritus may serve for up to a half of a year.

[2] The Publicity Manager shall be responsible for the publicity of all Glee Club events. He shall:

i. Securing opportunities for engagement with the University and Ann Arbor communities.

[3] The Publicity Manager shall oversee the Publicity Staff, which shall manage activities including social media, concert program creation and printing, photography, and campus publicity.

[4] The Assistant Publicity Manager shall serve under the Publicity Manager. He shall not have a vote on the Executive Committee. He shall be responsible for learning how to manage all aspects of Glee Club’s publicity and community engagement. 

[5] The Publicity Manager Emeritus shall advise the Publicity Manager and Assistant Publicity Manager and shall aid in the conception and execution of new publicity ventures on behalf of the Glee Club.

### Section 8. _Alumni Relations Manager, Assistant Alumni Relations Manager and Alumni Relations Manager Emeritus_

[1] The Assistant Alumni Relations Manager shall assume his duties immediately after selection by the Executive Committee. Following a half year of service at the end of Spring Tour the Assistant Alumni Relations Manager shall assume the role of Alumni Relations Manager. At that time, the individual who served as Alumni Relations Manager shall become the Alumni Relations Manager Emeritus. The Alumni Relations Manager Emeritus may serve for up to one year.

[2] The Alumni Relations Manager shall be responsible for maintaining and strengthening alumni relationships. He shall:

i. Serve as liaison to the Alumni Committee;

ii. Work with the advisor and pertinent development personnel and resources to organize all alumni solicitations;

iii. Be responsible for maintenance of all alumni records.

iv. Coordinate the Phone-a-Thon fundraiser;

v. Oversee all other correspondence with alumni, including the production of Laudes and E-Laudes each semester.

[3] The Alumni Relations Manager shall oversee the Alumni Relations Staff, which shall manage activities including the Glee Club archives, and recordings.

[4] The Assistant Alumni Relations Manager shall serve under the Alumni Relations Manager. He shall be responsible for learning how to manage all aspects of the Glee Club’s alumni relations. He shall have access to all alumni records.

[5] The Alumni Relations Manager Emeritus shall advise the Alumni Relations Manager and Assistant Alumni Relations Manager and shall aid in the conception and execution of new alumni relations ventures on behalf of the Glee Club. The Alumni Relations Manager Emeritus shall not have a vote on the Executive Committee.

### Section 9. _Diversity, Equity, and Inclusion Chair, Assistant DEI Chair, and DEI Chair Emeritus_

[1] The Assistant DEI Chair shall assume his duties immediately after selection by the Executive Committee. Following a half year of service at the end of Spring Tour, the Assistant DEI Chair shall assume the role of DEI Chair. At that time, the individual who served as DEI social Chair shall become the DEI Chair Emeritus. The DEI Chair Emeritus may serve for up to one year. 

[2] The Diversity, Equity, and Inclusion Chair shall be responsible for ensuring that the Glee Club’s mission and vision remain consistent with the values of Diversity, Equity, and Inclusion. He shall: 

i. Collaborate with the Advisor, Music Director, President, Assistant Conductor, Executive Committee, and DEI Committee to plan and lead future DEI events and missions; 

ii. Collaborate with the Music Director and Assistant Director, as they initiate and guide, to help clubbers in exploring the historical significances and social nuances of the repertoire; 

iii. Seek and initiate partnership opportunities for community engagement and clubber growth; iv. Ensure commitment to DEI values in all aspects of club, including, but not limited to: auditions, outreach events, collaborations, musicianship, and everyday club life. 

[3] The DEI Chair shall create, represent, and oversee the DEI Committee; 

i. Form a committee, starting immediately after assuming his position as DEI Chair. 

[4] Ensure that the University of Michigan Men’s Glee Club is a safe place for all people, regardless of race, gender identity, sexuality, veteran status, religion, or any other identity. 

[5] The Assistant DEI Chair shall work under the direction of the DEI Chair. He shall not have a vote on the Executive Committee. The DEI Chair shall be responsible for connecting the Assistant DEI Chair to past partners. It is the Assistant DEI Chair’s responsibility to build a genuine relationship with the partners, based on trust. It will also be up to the Assistant DEI Chair to brainstorm new projects and help lead the DEI Committee. 

[6] The DEI Chair Emeritus shall assist in any ventures the current DEI Chair may see fit. The DEI Chair Emeritus shall take responsibility for advising the current DEI Chair and helping connect them with other DEI Leaders and partners. They must be an active member of the DEI Committee. The DEI Chair Emeritus shall not have a vote on the Executive Committee. 

### Section 10. _Music Director_

[1] The Music Director shall be a member of the Faculty of the University of Michigan School of Music. The Music Director shall be selected by the administration of the School of Music in consultation with the Executive Committee.

[2] The Music Director shall:

i. Have complete discretion over musical repertoire;

ii. Distribute a syllabus to the membership outlining expectations and duties of performing members;

iii. Conduct or arrange for a conductor for all scheduled Rehearsals and Performances;

iv. Appoint an accompanist and shall assign the accompanist’s duties;

v. Conduct musical auditions; and,

vi. Work with the Advisor and Alumni Committee in developing long-term plans for the Glee Club.

[3] The Music Director may appoint an Assistant Music Director and assign him duties, including maintenance of the music library.

### Section 10. _Advisor_

[1] The Advisor shall be a member of the faculty or a staff member at the University of Michigan. The Music Director shall nominate a candidate for Advisor subject to confirmation by the Executive Committee.

[2] The Advisor shall:

i. Offer guidance to the Executive Committee on business and financial operations, on University policies, and on alumni and community relations; and,

ii. Work with the Executive Board in developing long-term plans for the Glee Club.

### Section 12. _Parliamentarian_

[1] The Parliamentarian shall be responsible for ensuring that the Glee Club operates in accordance with its Constitution and Rules. Upon the inclusion of new members, the Parliamentarian will email the current version of the Constitution and Rules to all members, with the following file name format: UMMGC Constitution/Standing Rules (Club of XXXth, Fall/Winter Semester).

[2] The Parliamentarian shall:

i. Chair all Judiciary Boards, in accordance with Article V; and,

ii. Serve as a non-voting member of the Executive Committee.

[3] The Parliamentarian shall be elected by the membership at the Annual Meeting. He may not simultaneously serve on the Executive Committee. The former Parliamentarian shall continue in his office with respect to any matters before a Judiciary Board at the time of the Annual Meeting.

[4] The Parliamentarian shall ensure the proper application of this Constitution and offer advisory opinions on its interpretation if asked by any member of the Glee Club. These opinions shall not be binding on any member.

### Section 13. _Removal_

[1] A formal request for removal of the Music Director shall require a petition signed by three-fourths (3/4) of the Club membership. The Executive Committee shall present said petition and convey the sentiment of the Club to the School of Music.

[2] Removal from office of the President, Vice-President, or Parliamentarian shall require prior notice and a two-thirds (2/3) majority vote of the Glee Club. The Parliamentarian shall chair removal proceedings involving the President or Vice- President. In the event that the Parliamentarian is the subject of the removal, the Glee Club shall elect a chairman for the proceeding.

[3] Removal from office of the Advisor, an Executive Manager, an Assistant Executive Manager or Junior Manager shall require prior notice and the affirmative vote of five (5) members of the Executive Committee.

[4] In addition to the procedures listed above, any Executive Manager, Assistant Executive Manager, Junior Manager, or the Advisor may be removed by the Glee Club with prior notice and a two-thirds (2/3) majority vote of the Glee Club.

### Section 14. _Replacement of Officers_

Except as otherwise provided in this Article, upon the removal, resignation, or other inability to discharge the duties of a position by an officer, a new officer shall be elected or appointed to serve the remainder of that term as soon as possible, in a manner as closely adhering as possible to the standard procedures established above.

## ARTICLE V. JUDICIARY BOARD

### Section 1. _Powers and Duties_

[1] Resolving disputes regarding the interpretation of this Constitution shall be the duty of a Judiciary Board. This power includes the right to review presidential decisions regarding Executive Committee roles made under the power granted to him under Article IV, Section 3[2].

[2] A Judiciary Board shall be selected as the first item of business immediately following a request for judicial review. There shall be no standing Judiciary Board.

[3] Decisions of a Judiciary Board shall be final.

[4] Any member dismissed from good standing in the Glee Club shall have an absolute right to appeal the dismissal to a Judiciary Board.

### Section 2. _Composition of Judiciary Board_

[1] A Judiciary Board shall be chaired by the Parliamentarian, and shall consist of the President, Vice-President, and four (4) at-large members selected by the Glee Club.

[2] No member of the Executive Committee may serve as an at-large member of a Judiciary Board.

[3] No person that is a party to a dispute shall serve as a member of a Judiciary Board.

[4] In the event that the Parliamentarian is a party to a dispute before a Judiciary Board, the Club shall, at the time the panel is formed, elect an acting chair.

[5] In the event that the President or Vice-President is a party to a dispute before a Judiciary Board, the Club shall select an additional at-large member to serve on the panel.

### Section 3. _Judiciary Board Decisions_

[1] All decisions of a Judiciary Board require a majority vote. Each member of the Judiciary Board shall have an equal vote.

[2] A Judiciary Board shall render a decision within seven (7) days. The decision shall take the form of a written opinion approved by majority vote of the Board. Facts relating to individual members of the Glee Club disclosed in matters before the Board shall be held in the strictest confidence.

[3] The Executive Committee shall execute the decisions of the Judiciary Board in good faith.

[4] A Judiciary Board may ask for the testimony or opinion of any member of the Glee Club on any matter before it. Any testimony or opinion shall be given with the assurance of strict confidentiality.

## ARTICLE VI. NON-DISCRIMINATION POLICY

The Glee Club shall not discriminate against any member or prospective member on the basis of age, color, creed, disability, marital status, national origin or ancestry, race, religion, sexual orientation, gender expression, birth-assigned sex, or veteran status.

## ARTICLE VII. CONSTITUTIONAL PROCEDURES & ADOPTION OF OTHER RULES

### Section 1. _Constitutional Supremacy_

This Constitution shall be the ultimate governing document of the University of Michigan Glee Club, in accordance with the Club’s status as a Sponsored Student Organization and a class in the School of Music, Theatre, and Dance. No Rules, Policy, or other document of the Glee Club shall take precedence before it and any rule not deriving legitimacy from this Constitution shall not be recognized. This version of the Constitution supersedes all former Constitutions of the University of Michigan Men’s Glee Club.

### Section 2. _Constitutional Amendment_

[1] This Constitution may be altered in two ways. Alterations that maintain the structure of this Constitution shall be referred to as “changes” and do not require separate denotation at the end and in the header of the document. Alterations that change this Constitution in a major and visible manner shall be known as “amendments.” Changes and amendments will follow the same procedure for acceptance by the Glee Club.

[2] Amendments to this Constitution shall be presented to the Glee Club by the Executive Committee in its role as executive under Article IV, Section 1[1]. Amendments may originate in the Executive Committee.

[3] A proposed amendment must be presented by the Executive Committee only after it receives the signatures of one-half (1/2) the total voting membership.

[4] Each proposed amendment shall be presented at two consecutive regular Business Meetings. The amendment shall be voted upon at the second meeting.

[5] A presented amendment shall be considered enacted if approved by three-fourths (3/4) of the total voting membership in attendance at Business Meeting.

### Section 3. _Effect of Other Rules_

The Glee Club shall also be governed by the supplemental procedures adopted in the Glee Club’s Standing Rules.

### Section 4. _Date of effect_

This Constitution was approved on the 23rd of October 2022. It replaced the previous version which took effect on the 25th of September 2022.
    `;

  return (
    <>
      <PageTitle title="Constitution"></PageTitle>
      {/* End pagetitle */}
      <div className="constitution-wrapper flex flex-col items-center  justify-center main-div ">
        <ReactMarkdown children={constitution} />
      </div>
    </>
  );
};

export default ConstitutionPage;
